module.exports = __webpack_public_path__ + "img/logo_glarus_white.22e4bd82.png";